import React, { useEffect, useState } from "react";
import { DialogActions } from "@material-ui/core";
import DialogLayout from "../../../../partials/content/DialogLayout";
import { CustomOutlinedDisabledTextField } from "../../../../partials/content/Forms";
import { formatDate } from "../../../../utils/utils";
import { getVisitDetail } from "../../../../services/crm/salesJourney";
import SlcTaskDetail from "./slcTaskDetail";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { Card, Badge } from "react-bootstrap";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import ActivityTaskForm from "../journey/journeyDetail/activityTaskForm";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
function SlcVisitDetail({ visitID = 0, onCloseDialog }) {
  const { reload } = useGlobalData();
  const [journey, setJourney] = useState({ ID: 0, statusID: 2 });
  const [visit, setVisit] = useState({
    ID: 0,
    customer: { customerName: "" },
    lead: { leadName: "", contactName: "" },
    planVisitDate: DateTime.now().endOf("day"),
    actVisitDate: DateTime.now(),
    visitType: 1,
    description: "",
    visitActivities: [],
  });
  const [openVisitActivityForm, setOpenVisitActivityForm] = useState(false);
  const [openTaskDetail, setOpenTaskDetail] = useState(false);
  const [visitActivity, setVisitActivity] = useState({
    ID: 0,
  });
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    getVisitDetailData(visitID);
  }, [visitID, reload]);

  const slcVisitDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" renderActiveOnly>
            <TabPanel header="Visits" rightIcon="fas fa-route">
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Visit Header</strong>
                      </span>
                      <Badge
                        className="float-right ml-1"
                        variant={
                          visit.statusID === 1
                            ? "warning"
                            : visit.statusID === 2
                            ? "primary"
                            : visit.statusID === 3
                            ? "success"
                            : visit.statusID === 9
                            ? "danger"
                            : null
                        }
                      >
                        {visit.statusID !== 0
                          ? "Visit " + visit.statusName
                          : null}
                      </Badge>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          {visit.customer.ID > 0 ? (
                            <CustomOutlinedDisabledTextField
                              label="Customer Name"
                              value={visit.customer.customerName}
                            />
                          ) : visit.lead.ID > 0 ? (
                            <CustomOutlinedDisabledTextField
                              label="Lead"
                              value={
                                visit.lead.leadName +
                                " " +
                                visit.lead.contactName
                              }
                            />
                          ) : null}
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Plan Visit Date"
                                value={formatDate(visit.planVisitDate, true)}
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledTextField
                                label="Actual Visit Date"
                                value={formatDate(visit.actVisitDate, true)}
                              />
                            </div>
                          </div>
                          <CustomOutlinedDisabledTextField
                            label="Visit Type"
                            value={
                              visit.visitType === 1
                                ? "In Route Visit"
                                : "Out of Route Visit"
                            }
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Description"
                            value={visit.description}
                            multiline
                            minRows={5}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="accordion">
                <div className="card">
                  <Accordion
                    className="accordion"
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                  >
                    <AccordionTab
                      header={
                        <React.Fragment>
                          <i className="fas fa-sitemap"></i>
                          <span>
                            <strong>Visit Activities</strong>
                          </span>
                        </React.Fragment>
                      }
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <CustomDataTable
                            data={visit.visitActivities}
                            dataDetailColumns={slcVisitDetailColumn}
                            onRefreshData={() => {
                              getVisitDetailData(visitID);
                            }}
                            columns={[
                              {
                                header: "Activity",
                                field: "activityName",
                                body: (rowData) => (
                                  <React.Fragment>
                                    <ResponsiveEllipsis
                                      text={rowData.activityName}
                                      maxLine="1"
                                    />
                                  </React.Fragment>
                                ),
                                sortable: true,
                                filter: true,
                              },
                              {
                                header: "Status",
                                field: "statusName",
                                body: null,
                                sortable: true,
                                filter: true,
                              },
                              {
                                header: "Note",
                                field: "note",
                                body: null,
                                sortable: true,
                                filter: true,
                              },
                              {
                                header: "Actions",
                                body: (rowData) => (
                                  <React.Fragment>
                                    <BootstrapTooltip title="Task Detail">
                                      <button
                                        type="button"
                                        onClick={() => {
                                          setVisitActivity(rowData);
                                          setOpenTaskDetail(true);
                                        }}
                                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                                      >
                                        <i className="fas fa-list-alt"></i>
                                      </button>
                                    </BootstrapTooltip>
                                  </React.Fragment>
                                ),
                                sortable: false,
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
          </DialogActions>
        </div>
      </div>
      {visitActivity.ID > 0 ? (
        <DialogLayout
          open={openTaskDetail}
          title={`Visit Activity ${visitActivity.activityName} Tasks`}
          onCloseDialog={handleCloseTaskDetail}
        >
          <ActivityTaskForm
            journeyID={journey.ID}
            visitActivity={visitActivity}
            onSubmitSave={() => {}}
            onCloseDialog={() => {}}
          />
        </DialogLayout>
      ) : null}
    </React.Fragment>
  );

  function handleCloseTaskDetail() {
    setOpenTaskDetail(false);
  }

  async function getVisitDetailData(visitID) {
    const response = await getVisitDetail(visitID);
    const { data } = response.data;
    setVisit(data.visit);
    setJourney(data.journey);
  }
}

export default SlcVisitDetail;
